import { useEffect, useRef } from 'react';


// Calls `handler` on mousedown/touchstart outside of the returned ref element.
// Replaces react-onclickoutside / react-outside-click-handler.
const useOutsideClick = (handler) => {
  const ref = useRef(null);
  const handlerRef = useRef(handler);

  useEffect(() => {
    handlerRef.current = handler;
  }, [handler]);

  useEffect(() => {
    const listener = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        handlerRef.current(event);
      }
    };
    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, []);

  return ref;
};

export default useOutsideClick;
